import { Fragment } from "react"
import Footer from "./Footer"
import Header from "./Header"
import Sidebar from "./Sidebar"
import { Outlet } from "react-router-dom"
import React from "react"
function Layout() {
    return (
        <Fragment>
            <div id="layout-wrapper">
                <Header />
                <Sidebar />
                <Outlet />
            </div>
            <Footer />
        </Fragment>
    )
}
export default Layout